export default __webpack_public_path__ + "static/media/Play_Icon.4b232195.svg";